module.exports = __webpack_public_path__ + "static/media/icon-circles.387dec63.svg";